module.exports = __webpack_public_path__ + "static/media/hourglass.a62a7386.png";